import React, { useEffect, useState } from 'react';
import { initScrollReveal } from './utils/scrollReveal';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductGallery from './components/ProductGallery';
import Features from './components/Features';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize scroll animations after loading is done or immediately if strictly needed
    // We'll call it again in handleLoadComplete just to be sure
  }, []);

  const handleLoadComplete = () => {
    setLoading(false);
    // slight delay to ensure DOM is ready
    setTimeout(() => {
      initScrollReveal();
    }, 100);
  };

  return (
    <div className="bg-dark-900 min-h-screen text-white selection:bg-royal-500 selection:text-white">
      {loading && <Loader onLoadComplete={handleLoadComplete} />}
      <div
        className="transition-opacity duration-1000 ease-out"
        style={{ opacity: loading ? 0 : 1 }}
      >
        <Navbar />
        <Hero />
        <ProductGallery />
        <Features />
        <ContactForm />
        <Footer />
      </div>
    </div>
  );
}

export default App;
